import { render } from "./Cerrar.vue?vue&type=template&id=31c9ddab"
import script from "./Cerrar.vue?vue&type=script&lang=js"
export * from "./Cerrar.vue?vue&type=script&lang=js"

import "./Cerrar.vue?vue&type=style&index=0&id=31c9ddab&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__